export enum DataComponents {
  Component1 = 'Component1',
  Component2 = 'Component2',
  Component3_ACC_PL = 'Component3_ACC_PL',
  Component4_ACC_SF = 'Component4_ACC_SF',
  Component5_STAFF = 'Component5_STAFF',
  Component6_FACILITIES = 'Component6_FACILITIES',
  Component7_TEAMS = 'Component7_TEAMS',
  Component8_PLAYERS = 'Component8_PLAYERS',
}

export interface DCData {
  [DataComponents.Component1]?: any;
  [DataComponents.Component2]?: any;
  [DataComponents.Component3_ACC_PL]?: any;
  [DataComponents.Component4_ACC_SF]?: any;
  [DataComponents.Component5_STAFF]?: any;
  [DataComponents.Component6_FACILITIES]?: any;
  [DataComponents.Component7_TEAMS]?: any;
  [DataComponents.Component8_PLAYERS]?: any;
}

export enum FacilityStatus {
  FS_OWNED = 'FS_OWNED',
  FS_PRIORITY = 'FS_PRIORITY',
  FS_PUBLIC = 'FS_PUBLIC',
}

export const facilityStatusNaming:any = {
  [FacilityStatus.FS_OWNED]: 'DC_FS_OWNED',
  [FacilityStatus.FS_PRIORITY]: 'DC_FS_PRIORITY',
  [FacilityStatus.FS_PUBLIC]: 'DC_FS_PUBLIC',
};

export enum Capabilities {
  CAP_CLUB_HOUSE = 'CAP_CLUB_HOUSE',
  CAP_MEDICAL_ROOM = 'CAP_MEDICAL_ROOM',
  CAP_COLD_SHOWERS = 'CAP_COLD_SHOWERS',
  CAP_HOT_SHOWERS = 'CAP_HOT_SHOWERS',
  CAP_SOCCER_GOAL_POSSESSION_ADULT = 'CAP_SOCCER_GOAL_POSSESSION_ADULT',
  CAP_SOCCER_GOAL_POSSESSION_JUNIOR = 'CAP_SOCCER_GOAL_POSSESSION_JUNIOR',
  CAP_SOCCER_GOAL_POSSESSION_KIDS = 'CAP_SOCCER_GOAL_POSSESSION_KIDS',
  CAP_DORMITORY = 'CAP_DORMITORY',
  CAP_CHANGING_ROOMS = 'CAP_CHANGING_ROOMS',
}

export const capabilitiesNaming:any = {
  [Capabilities.CAP_CLUB_HOUSE]: 'DC_CAP_CLUB_HOUSE',
  [Capabilities.CAP_MEDICAL_ROOM]: 'DC_CAP_MEDICAL_ROOM',
  [Capabilities.CAP_COLD_SHOWERS]: 'DC_CAP_COLD_SHOWERS',
  [Capabilities.CAP_HOT_SHOWERS]: 'DC_CAP_HOT_SHOWERS',
  [Capabilities.CAP_SOCCER_GOAL_POSSESSION_ADULT]: 'DC_CAP_SOCCER_GOAL_POSSESSION_ADULT',
  [Capabilities.CAP_SOCCER_GOAL_POSSESSION_JUNIOR]: 'DC_CAP_SOCCER_GOAL_POSSESSION_JUNIOR',
  [Capabilities.CAP_SOCCER_GOAL_POSSESSION_KIDS]: 'DC_CAP_SOCCER_GOAL_POSSESSION_KIDS',
  [Capabilities.CAP_DORMITORY]: 'DC_CAP_DORMITORY',
  [Capabilities.CAP_CHANGING_ROOMS]: 'DC_CAP_CHANGING_ROOMS',
};

export enum Turf {
  TURF_1 = 'TURF_1',
  TURF_2 = 'TURF_2',
  TURF_3 = 'TURF_3',
  TURF_4 = 'TURF_4',
  TURF_5 = 'TURF_5',
  TURF_6 = 'TURF_6',
  TURF_7 = 'TURF_7',
  TURF_8 = 'TURF_8',
}

export const turfNaming:any = {
  [Turf.TURF_1]: 'DC_6_TURF_1',
  [Turf.TURF_2]: 'DC_6_TURF_2',
  [Turf.TURF_3]: 'DC_6_TURF_3',
  [Turf.TURF_4]: 'DC_6_TURF_4',
  [Turf.TURF_5]: 'DC_6_TURF_5',
  [Turf.TURF_6]: 'DC_6_TURF_6',
  [Turf.TURF_7]: 'DC_6_TURF_7',
  [Turf.TURF_8]: 'DC_6_TURF_8',
};

export enum EmploymentStatus {
  ES_FULL_TIME = 'ES_FULL_TIME',
  ES_PART_TIME = 'ES_PART_TIME',
  ES_CONSULTANT = 'ES_CONSULTANT',
  ES_STUDENT = 'ES_STUDENT',
  ES_VOLUNTEER = 'ES_VOLUNTEER',
}

export const employmentStatusNaming:any = {
  [EmploymentStatus.ES_FULL_TIME]: 'DC_ES_FULL_TIME',
  [EmploymentStatus.ES_PART_TIME]: 'DC_ES_PART_TIME',
  [EmploymentStatus.ES_CONSULTANT]: 'DC_ES_CONSULTANT',
  [EmploymentStatus.ES_STUDENT]: 'DC_ES_STUDENT',
  [EmploymentStatus.ES_VOLUNTEER]: 'DC_ES_VOLUNTEER',
};

export enum RegisteredPosition {
  DC_RP_HEAD_COACH = 'DC_RP_HEAD_COACH',
  RP_ACADEMY_DIRECTOR = 'RP_ACADEMY_DIRECTOR',
  RP_ACADEMIC_TEAM_DIRECTOR = 'RP_ACADEMIC_TEAM_DIRECTOR',
  RP_ACADEMIC_TEAM_COACH = 'RP_ACADEMIC_TEAM_COACH',
  RP_SCHOOL_COACH = 'RP_SCHOOL_COACH',
  RP_OTHER = 'RP_OTHER',
}

export const registeredPositionNaming = {
  [RegisteredPosition.DC_RP_HEAD_COACH]: 'DC_RP_HEAD_COACH',
  [RegisteredPosition.RP_ACADEMY_DIRECTOR]: 'DC_RP_ACADEMY_DIRECTOR',
  [RegisteredPosition.RP_ACADEMIC_TEAM_DIRECTOR]: 'DC_RP_ACADEMIC_TEAM_DIRECTOR',
  [RegisteredPosition.RP_ACADEMIC_TEAM_COACH]: 'DC_RP_ACADEMIC_TEAM_COACH',
  [RegisteredPosition.RP_SCHOOL_COACH]: 'DC_RP_SCHOOL_COACH',
  [RegisteredPosition.RP_OTHER]: 'DC_RP_OTHER',
};

export enum LeadershipRole {
  'LR_HEAD_OF_DEV_DEP' = 'LR_HEAD_OF_DEV_DEP',
  'LR_U18_COACH' = 'LR_U18_COACH',
  'LR_U15_COACH' = 'LR_U15_COACH',
  'LR_U12_COACH' = 'LR_U12_COACH',
  'LR_ACADEMY_TC' = 'LR_ACADEMY_TC',
}

export const leadershipRoleNaming = {
  [LeadershipRole.LR_HEAD_OF_DEV_DEP]: 'DC_5_ROLE_A',
  [LeadershipRole.LR_U18_COACH]: 'DC_5_ROLE_B',
  [LeadershipRole.LR_U15_COACH]: 'DC_5_ROLE_C',
  [LeadershipRole.LR_U12_COACH]: 'DC_5_ROLE_D',
  [LeadershipRole.LR_ACADEMY_TC]: 'DC_5_ROLE_E',
};

export enum Qualifications {
  'DC_Q_QUALIFICATION1' = 'DC_Q_QUALIFICATION1',
  'DC_Q_QUALIFICATION2' = 'DC_Q_QUALIFICATION2',
  // 'DC_Q_QUALIFICATION3' = 'DC_Q_QUALIFICATION3',
  'DC_Q_QUALIFICATION4' = 'DC_Q_QUALIFICATION4',
  'DC_Q_QUALIFICATION5' = 'DC_Q_QUALIFICATION5',
  'DC_Q_QUALIFICATION6' = 'DC_Q_QUALIFICATION6',
  'DC_Q_QUALIFICATION7' = 'DC_Q_QUALIFICATION7',
  'DC_Q_QUALIFICATION8' = 'DC_Q_QUALIFICATION8',
  'DC_Q_QUALIFICATION9' = 'DC_Q_QUALIFICATION9',
  'DC_Q_QUALIFICATION10' = 'DC_Q_QUALIFICATION10',
  'DC_Q_QUALIFICATION11' = 'DC_Q_QUALIFICATION11',
  'DC_Q_QUALIFICATION12' = 'DC_Q_QUALIFICATION12',
  'DC_Q_QUALIFICATION13' = 'DC_Q_QUALIFICATION13',
  'DC_Q_QUALIFICATION14' = 'DC_Q_QUALIFICATION14',
  'DC_Q_QUALIFICATION15' = 'DC_Q_QUALIFICATION15',
  'DC_Q_QUALIFICATION16' = 'DC_Q_QUALIFICATION16',
  'DC_Q_QUALIFICATION17' = 'DC_Q_QUALIFICATION17',
  'DC_Q_QUALIFICATION18' = 'DC_Q_QUALIFICATION18',
  'DC_Q_QUALIFICATION19' = 'DC_Q_QUALIFICATION19',
  'DC_Q_QUALIFICATION20' = 'DC_Q_QUALIFICATION20',
  'DC_Q_QUALIFICATION21' = 'DC_Q_QUALIFICATION21',
  'DC_Q_QUALIFICATION22' = 'DC_Q_QUALIFICATION22',
  'DC_Q_QUALIFICATION23' = 'DC_Q_QUALIFICATION23',
  'DC_Q_QUALIFICATION24' = 'DC_Q_QUALIFICATION24',
  'DC_Q_QUALIFICATION25' = 'DC_Q_QUALIFICATION25',
  'DC_Q_QUALIFICATION26' = 'DC_Q_QUALIFICATION26',
  'DC_Q_QUALIFICATION27' = 'DC_Q_QUALIFICATION27',
  'DC_Q_QUALIFICATION28' = 'DC_Q_QUALIFICATION28',
  'DC_Q_QUALIFICATION29' = 'DC_Q_QUALIFICATION29',
}

export const qualificationsNaming:any = {
  [Qualifications.DC_Q_QUALIFICATION1]:
    'DC_Q_QUALIFICATION1',
    [Qualifications.DC_Q_QUALIFICATION2]:
    'DC_Q_QUALIFICATION2',
    // [Qualifications.DC_Q_QUALIFICATION3]:
    // 'DC_Q_QUALIFICATION3',
    [Qualifications.DC_Q_QUALIFICATION4]:
    'DC_Q_QUALIFICATION4',
    [Qualifications.DC_Q_QUALIFICATION5]:
    'DC_Q_QUALIFICATION5',
    [Qualifications.DC_Q_QUALIFICATION6]:
    'DC_Q_QUALIFICATION6',
    [Qualifications.DC_Q_QUALIFICATION7]:
    'DC_Q_QUALIFICATION7',
    [Qualifications.DC_Q_QUALIFICATION8]:
    'DC_Q_QUALIFICATION8',
    [Qualifications.DC_Q_QUALIFICATION9]:
    'DC_Q_QUALIFICATION9',
    [Qualifications.DC_Q_QUALIFICATION10]:
    'DC_Q_QUALIFICATION10',
    [Qualifications.DC_Q_QUALIFICATION11]:
    'DC_Q_QUALIFICATION11',
    [Qualifications.DC_Q_QUALIFICATION12]:
    'DC_Q_QUALIFICATION12',
    [Qualifications.DC_Q_QUALIFICATION13]:
    'DC_Q_QUALIFICATION13',
    [Qualifications.DC_Q_QUALIFICATION14]:
    'DC_Q_QUALIFICATION14',
    [Qualifications.DC_Q_QUALIFICATION15]:
    'DC_Q_QUALIFICATION15',
    [Qualifications.DC_Q_QUALIFICATION16]:
    'DC_Q_QUALIFICATION16',
    [Qualifications.DC_Q_QUALIFICATION17]:
    'DC_Q_QUALIFICATION17',
    [Qualifications.DC_Q_QUALIFICATION18]:
    'DC_Q_QUALIFICATION18',
    [Qualifications.DC_Q_QUALIFICATION19]:
    'DC_Q_QUALIFICATION19',
    [Qualifications.DC_Q_QUALIFICATION20]:
    'DC_Q_QUALIFICATION20',
    [Qualifications.DC_Q_QUALIFICATION21]:
    'DC_Q_QUALIFICATION21',
    [Qualifications.DC_Q_QUALIFICATION22]:
    'DC_Q_QUALIFICATION22',
    [Qualifications.DC_Q_QUALIFICATION23]:
    'DC_Q_QUALIFICATION23',
    [Qualifications.DC_Q_QUALIFICATION24]:
    'DC_Q_QUALIFICATION24',
    [Qualifications.DC_Q_QUALIFICATION25]:
    'DC_Q_QUALIFICATION25',
    [Qualifications.DC_Q_QUALIFICATION26]:
    'DC_Q_QUALIFICATION26',
    [Qualifications.DC_Q_QUALIFICATION27]:
    'DC_Q_QUALIFICATION27',
    [Qualifications.DC_Q_QUALIFICATION28]:
    'DC_Q_QUALIFICATION28',
    [Qualifications.DC_Q_QUALIFICATION29]:
    'DC_Q_QUALIFICATION29',
};

export enum AgeGroup {
  'AG_U18' = 'AG_U18',
  'AG_U17' = 'AG_U17',
  'AG_U16' = 'AG_U16',
  'AG_U15' = 'AG_U15',
  'AG_U14' = 'AG_U14',
  'AG_U13' = 'AG_U13',
  'AG_U12' = 'AG_U12',
  'AG_U11' = 'AG_U11',
  'AG_U10' = 'AG_U10',
  'AG_U9' = 'AG_U9',
}

export const ageGroupNaming:any = {
  [AgeGroup.AG_U18]: 'DC_AG_U18',
  [AgeGroup.AG_U17]: 'DC_AG_U17',
  [AgeGroup.AG_U16]: 'DC_AG_U16',
  [AgeGroup.AG_U15]: 'DC_AG_U15',
  [AgeGroup.AG_U14]: 'DC_AG_U14',
  [AgeGroup.AG_U13]: 'DC_AG_U13',
  [AgeGroup.AG_U12]: 'DC_AG_U12',
  [AgeGroup.AG_U11]: 'DC_AG_U11',
  [AgeGroup.AG_U10]: 'DC_AG_U10',
  [AgeGroup.AG_U9]: 'DC_AG_U9',
};

export enum PositionAchieved {
  'PA_WINNER' = 'PA_WINNER',
  'PA_SEMI_FINAL' = 'PA_SEMI_FINAL',
  'PA_QUARTER_FINAL' = 'PA_QUARTER_FINAL',
  'PA_LAST_16' = 'PA_LAST_16',
  'PA_GROUP' = 'PA_GROUP',
  'PA_2ND' = 'PA_2ND',
  'PA_3RD' = 'PA_3RD',
  'PA_4TH' = 'PA_4TH',
  'PA_5TH' = 'PA_5TH',
  'PA_6TH' = 'PA_6TH',
  'PA_7TH' = 'PA_7TH',
  'PA_8TH' = 'PA_8TH',
  'PA_9TH' = 'PA_9TH',
  'PA_10TH' = 'PA_10TH',
  'PA_11TH' = 'PA_11TH',
  'PA_12TH' = 'PA_12TH',
  'PA_13TH' = 'PA_13TH',
  'PA_14TH' = 'PA_14TH',
  'PA_15TH' = 'PA_15TH',
  'PA_16TH' = 'PA_16TH',
  'PA_17TH' = 'PA_17TH',
  'PA_18TH' = 'PA_18TH',
  'PA_19TH' = 'PA_19TH',
  'PA_20TH' = 'PA_20TH',
  'PA_21ST' = 'PA_21ST',
  'PA_22ND' = 'PA_22ND',
  'PA_23RD' = 'PA_23RD',
  'PA_24TH' = 'PA_24TH',
  'PA_25TH' = 'PA_25TH',
  'PA_26TH' = 'PA_26TH',
  'PA_27TH' = 'PA_27TH',
  'PA_28TH' = 'PA_28TH',
  'PA_29TH' = 'PA_29TH',
  'PA_30TH' = 'PA_30TH',
}

export const positionAchievedNaming:any = {
  [PositionAchieved.PA_WINNER]: 'DC_PA_WINNER',
  [PositionAchieved.PA_SEMI_FINAL]: 'DC_PA_SEMI_FINAL',
  [PositionAchieved.PA_QUARTER_FINAL]: 'DC_PA_QUARTER_FINAL',
  [PositionAchieved.PA_LAST_16]: 'DC_PA_LAST_16',
  [PositionAchieved.PA_GROUP]: 'DC_PA_GROUP',
  [PositionAchieved.PA_2ND]: 'DC_PA_2ND',
  [PositionAchieved.PA_3RD]: 'DC_PA_3RD',
  [PositionAchieved.PA_4TH]: 'DC_PA_4TH',
  [PositionAchieved.PA_5TH]: 'DC_PA_5TH',
  [PositionAchieved.PA_6TH]: 'DC_PA_6TH',
  [PositionAchieved.PA_7TH]: 'DC_PA_7TH',
  [PositionAchieved.PA_8TH]: 'DC_PA_8TH',
  [PositionAchieved.PA_9TH]: 'DC_PA_9TH',
  [PositionAchieved.PA_10TH]: 'DC_PA_10TH',
  [PositionAchieved.PA_11TH]: 'DC_PA_11TH',
  [PositionAchieved.PA_12TH]: 'DC_PA_12TH',
  [PositionAchieved.PA_13TH]: 'DC_PA_13TH',
  [PositionAchieved.PA_14TH]: 'DC_PA_14TH',
  [PositionAchieved.PA_15TH]: 'DC_PA_15TH',
  [PositionAchieved.PA_16TH]: 'DC_PA_16TH',
  [PositionAchieved.PA_17TH]: 'DC_PA_17TH',
  [PositionAchieved.PA_18TH]: 'DC_PA_18TH',
  [PositionAchieved.PA_19TH]: 'DC_PA_19TH',
  [PositionAchieved.PA_20TH]: 'DC_PA_20TH',
  [PositionAchieved.PA_21ST]: 'DC_PA_21ST',
  [PositionAchieved.PA_22ND]: 'DC_PA_22ND',
  [PositionAchieved.PA_23RD]: 'DC_PA_23RD',
  [PositionAchieved.PA_24TH]: 'DC_PA_24TH',
  [PositionAchieved.PA_25TH]: 'DC_PA_25TH',
  [PositionAchieved.PA_26TH]: 'DC_PA_26TH',
  [PositionAchieved.PA_27TH]: 'DC_PA_27TH',
  [PositionAchieved.PA_28TH]: 'DC_PA_28TH',
  [PositionAchieved.PA_29TH]: 'DC_PA_29TH',
  [PositionAchieved.PA_30TH]: 'DC_PA_30TH',
};
export interface Staff {
  id: number | null;
  kanjiName: string;
  katakanaName: string;
  englishName: string;
  dateOfBirth: string;
  jfaId: string;
  instructorRegistrationNumber: string;
  employmentStatus: EmploymentStatus;
  department: string[];
  licenceStart: string;
  licenceEnd: string;
  registeredPosition: RegisteredPosition[];
  jobTitle: string;
  leadershipRole: LeadershipRole[];
  annualSalary: number;
  qualifications: Qualifications[];
  competitionCareers: { id: number | null; club: string; yearFrom: number; yearTo: number }[];
  coachingCareers: { id: number | null; club: string; yearFrom: number; yearTo: number }[];
  mainDuties: string;
}

export interface StaffRoles {
  id: number;
  staffId: number[];
}

export interface ProfitLoss {
  total: {
    year: string;
    mandatory: boolean;
    name: string | null;
    otherExpenseName: string | null;
    currentYear: number;
    nextYear: number;
    type: string;
  }[];
  income: {
    year: string;
    mandatory: boolean;
    name: string | null;
    otherExpenseName: string | null;
    currentYear: number;
    nextYear: number;
    type: string;
  }[];
  expense: {
    year: string;
    mandatory: boolean;
    name: string | null;
    otherExpenseName: string | null;
    currentYear: number;
    nextYear: number;
    type: string;
  }[];
  totalAcademyIncome: {
    year: string;
    mandatory: boolean;
    name: string | null;
    otherExpenseName: string | null;
    currentYear: number;
    nextYear: number;
    type: string;
  };
  totalAcademyExpense: {
    year: string;
    mandatory: boolean;
    name: string | null;
    otherExpenseName: string | null;
    currentYear: number;
    nextYear: number;
    type: string;
  };
}

export interface Facility {
  id: number | null;
  facilityName: string;
  shortName: string;
  address: string;
  owner: string;
  facilityStatus: FacilityStatus;
  capabilities: Capabilities[];
  changingRooms: number;
  dormitoryCapacity: number;
  dormitoryRemarks: string;
  facilityGrounds: {
    id: number | null;
    name: string;
    width: number;
    depth: number;
    spectators: number;
    turf: Turf[];
    illumination: string[];
  }[];
}

export interface Team {
  id: number | null;
  teamDetails: {
    teamName: string;
    established: number;
    ageGroup: AgeGroup;
    staffSupervisor: number | null;
    staffCoaches: number[];
    staffGkCoaches: number[];
    medicalStaff: number[];
    practiceGrounds: number[];
  };
  playerAges: {
    u18: number;
    u17: number;
    u16: number;
    u15: number;
    u14: number;
    u13: number;
    u12: number;
    u11: number;
    u10: number;
    u9: number;
  };
  trainingSchedule: {
    mon: { id: number | null; start: string | Date; end: string  | Date; grounds: number[]; remarks: string };
    tue: { id: number | null; start: string  | Date; end: string  | Date; grounds: number[]; remarks: string };
    wed: { id: number | null; start: string  | Date; end: string  | Date; grounds: number[]; remarks: string };
    thur: { id: number | null; start: string  | Date; end: string  | Date; grounds: number[]; remarks: string };
    fri: { id: number | null; start: string  | Date; end: string  | Date; grounds: number[]; remarks: string };
    sat: { id: number | null; start: string  | Date; end: string  | Date; grounds: number[]; remarks: string };
    sun: { id: number | null; start: string  | Date; end: string  | Date; grounds: number[]; remarks: string };
  };
  teamFees: {
    admissionFees: number;
    playerMonthlyExpense: number;
    travelMonthlyExpense: number;
    remarks: string;
  };
  titles: { id: number | null; competition: string; yearAchieved: number }[];
  competitions: { id: number | null; competition: string; position: PositionAchieved }[];
}

export interface Player {
  id: number | null;
  playerId: number;
  name: string;
  dateOfBirth: string | null;
  currentClub: string;
  international: string;
  academyPeriods: { id: number | null; dateFrom: string | null; dateTo: string | null }[];
  clubCareers: { id: number | null; country: string; club: string; dateFrom: string | null; dateTo: string | null }[];
  internationalCareers: {
    id: number | null;
    ageGroup: AgeGroup;
    country: string;
    club: string;
    dateFrom: string | null;
    dateTo: string | null;
  }[];
}

export interface DataComponentsFormProps {
  dataCapture: {
    [DataComponents.Component1]: { companyName: string; executiveMember: string; academyDirector: string };
    [DataComponents.Component2]: {
      name: string;
      department: string;
      phone: string;
      fax: string;
      mobile: string;
      workLocation: string;
      email: string;
    };
    [DataComponents.Component3_ACC_PL]: ProfitLoss;
    [DataComponents.Component4_ACC_SF]: { id: number; description: string; amount: number }[];
    [DataComponents.Component5_STAFF]: { staff: Staff[] };
    [DataComponents.Component6_FACILITIES]: Facility[];
    [DataComponents.Component7_TEAMS]: Team[];
    [DataComponents.Component8_PLAYERS]: Player[];
  };
}
